import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Building2, Loader2, Save } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

// Structure de stage envisagée : saisie libre (indicative) avec suggestions de la base des structures
export const StructureStageCard = ({ candidatId, valeur }) => {
  const [texte, setTexte] = useState(valeur || '');
  const [suggestions, setSuggestions] = useState([]);
  const [ouvert, setOuvert] = useState(false);
  const [saving, setSaving] = useState(false);
  const [enregistre, setEnregistre] = useState(valeur || '');

  useEffect(() => { setTexte(valeur || ''); setEnregistre(valeur || ''); }, [valeur]);

  useEffect(() => {
    if (!ouvert || texte.trim().length < 2) { setSuggestions([]); return undefined; }
    const t = setTimeout(() => {
      axios.get('/candidats/structures-suggestions', { params: { q: texte } })
        .then(res => setSuggestions(res.data || [])).catch(() => setSuggestions([]));
    }, 250);
    return () => clearTimeout(t);
  }, [texte, ouvert]);

  const enregistrer = async () => {
    setSaving(true);
    try {
      const res = await axios.put(`/candidats/${candidatId}/structure-stage`, { structure_stage_envisagee: texte });
      setEnregistre(res.data.structure_stage_envisagee);
      toast.success('Structure de stage enregistrée');
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erreur lors de l'enregistrement");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card data-testid="structure-stage-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <Building2 className="h-5 w-5 text-[#8DC63F]" />
          Structure de stage envisagée
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        <p className="text-xs text-slate-500">À titre indicatif. Saisie libre, les structures connues sont proposées.</p>
        <div className="relative">
          <Input value={texte} placeholder="Nom de la structure"
            onChange={e => { setTexte(e.target.value); setOuvert(true); }}
            onFocus={() => setOuvert(true)} onBlur={() => setTimeout(() => setOuvert(false), 150)}
            data-testid="input-structure-stage" />
          {ouvert && suggestions.length > 0 && (
            <div className="absolute z-20 mt-1 w-full bg-white border rounded-md shadow-lg max-h-56 overflow-y-auto" data-testid="structure-stage-suggestions">
              {suggestions.map(s => (
                <button key={s.nom} type="button" className="w-full text-left px-3 py-2 text-sm hover:bg-slate-50"
                  onMouseDown={() => { setTexte(s.nom); setOuvert(false); }} data-testid={`suggestion-structure-${s.nom}`}>
                  <span className="font-medium">{s.nom}</span>
                  {s.ville && <span className="text-slate-400 ml-2">{s.ville}</span>}
                </button>
              ))}
            </div>
          )}
        </div>
        <Button size="sm" onClick={enregistrer} disabled={saving || texte.trim() === enregistre.trim()} className="bg-[#8DC63F] hover:bg-[#7AB62F] text-white" data-testid="btn-save-structure-stage">
          {saving ? <Loader2 className="h-4 w-4 animate-spin mr-1" /> : <Save className="h-4 w-4 mr-1" />}
          Enregistrer
        </Button>
      </CardContent>
    </Card>
  );
};
